import React, { useState } from 'react';

import GetAppIcon from '@mui/icons-material/GetApp';

import { Box, IconButton, CircularProgress, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';


import { copyToClipboard } from '../../../common/commons';


const useStyles = makeStyles(() => ({
    toolbar: {
        textAlign: "right",
        height: '35px',
        marginRight: '15px',
        '& .MuiButtonBase-root': {
            padding: '5px !important'
        }
    },
    JsonContentWrapper: {
        minHeight: '600px',
        background: '#ffffff',
        boxShadow: 'inset 0rem 0rem 0.25rem rgb(0 0 0 / 8%)',
       
    },
    preTagOverflow:{
        overflowY:"scroll",
        maxHeight:"700px"
    },
    copyToClipboard: {
        position: 'absolute',
        right: '30px'
    }
}));


const ViewGeneratedJson = ({ json, dsarRequestId, processing }) => {
   
    const classes = useStyles();
  
    const [showCopySuccess, setShowCopySuccess] = useState(false);

    const downloadJSON = () => {
    
        const link = document.createElement("a");
        const file = new Blob([JSON.stringify(json, null, 4)], {
            type: "application/json",
        });

        link.href = URL.createObjectURL(file);
        let linkAttr = dsarRequestId;
       
        link.setAttribute("download", `${linkAttr}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
    const copyClip = ()=>{
        copyToClipboard(json);
        setShowCopySuccess(true);
        setTimeout(() => {
            setShowCopySuccess(false);
        }, 1500);
    }

    return (<Box width={"100%"} height={"62%"} overflow={"hidden"}>
        <div className={classes.toolbar}>
            <Tooltip title={"download"}>
                <span>
                    <IconButton disabled={!json} onClick={() => { downloadJSON() }} aria-label="download">
                        <GetAppIcon />
                    </IconButton>
                </span>
            </Tooltip>
        </div>
        <Box className={classes.JsonContentWrapper}>
            <Tooltip open={showCopySuccess} title="Copied!" position="bottom" >
                <span>
                    <IconButton className={classes.copyToClipboard} disabled={!json} onClick={() => { 
                        copyClip()
                        }} aria-label="copy to Clipboard">
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor"/>
                    </svg>
                </IconButton>
                </span>
            </Tooltip>
            <pre className={classes.preTagOverflow} >{json && JSON.stringify(json, null, 2)}</pre>
             {processing && <Box 
             display="flex"
             justifyContent="center"
             alignItems="center"
             ><CircularProgress size={40} className={classes.buttonProgress} /></Box>}
        </Box>

    </Box>)
}
export default React.memo(ViewGeneratedJson);

